import { Component, computed, inject, input } from '@angular/core';

import { FooterComponent as UIFooter } from '@valk-nx/components/ui-footer/src/lib/footer';
import type { FooterMenuItems } from '@valk-nx/components/ui-footer/src/lib/footer.interface';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { StoryblokHelper } from '@valk-nx/storyblok-helpers/src/lib/general/storyblok.helper';
import { MenuItemsModule } from '@valk-nx/storyblok-pipes/src/lib/pipes/menu-items/menu-items.module';
import { HotelStore } from '@valk-nx/storyblok-store/src/lib/store/hotel/hotel.store';
import type {
	Link,
	MenuItem,
	SbFooterMenu,
} from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

@Component({
	selector: 'sb-footer',
	templateUrl: './footer.html',
	imports: [UIFooter, StoryblokDirective, MenuItemsModule],
})
export class FooterComponent extends StoryblokRootDirective {
	readonly hotelStore = inject(HotelStore);

	title = input<string>();
	usps = input<MenuItem[]>();
	bottomMenu = input.required<MenuItem[]>();
	footerMenu = input.required<FooterMenuItems[]>();
	menu = input<SbFooterMenu[]>();

	// Socials
	facebook = input<Link>();
	instagram = input<Link>();
	linkedin = input<Link>();
	pinterest = input<Link>();
	tiktok = input<Link>();
	whatsapp = input<string>();
	youtube = input<Link>();

	footerMenuItems = computed<FooterMenuItems[]>(() => {
		const footerMenu = this.footerMenu();
		const menu = this.menu();
		if (menu && menu.length > 0) {
			return this.constructFooterMenu(menu);
		}

		return footerMenu.length > 0 ? footerMenu : [];
	});

	socials = computed(() => {
		return {
			facebook: StoryblokHelper.getUrlFromStoryblokLink(this.facebook()),
			instagram: StoryblokHelper.getUrlFromStoryblokLink(
				this.instagram(),
			),
			linkedin: StoryblokHelper.getUrlFromStoryblokLink(this.linkedin()),
			pinterest: StoryblokHelper.getUrlFromStoryblokLink(
				this.pinterest(),
			),
			tiktok: StoryblokHelper.getUrlFromStoryblokLink(this.tiktok()),
			whatsapp: this.whatsapp(),
			youtube: StoryblokHelper.getUrlFromStoryblokLink(this.youtube()),
		};
	});

	constructFooterMenu(menu: SbFooterMenu[]): FooterMenuItems[] {
		return menu?.map((menuItem) => {
			return {
				title: menuItem.title,
				items: menuItem.items?.map((item) => {
					return {
						title: item.title,
						url: item.link.cached_url,
						target: item.link.target ?? '_self',
					};
				}),
			};
		});
	}
}
